export default __webpack_public_path__ + "static/media/check.8fead2a3.svg";